import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectLogin = (state) => state.login || initialState;

const selectLoginError = createSelector(selectLogin, (loginState) => loginState.loginError);

export { selectLoginError };
